import { LoggedInDevAIFree } from "./free/logged-in-devai-free";

export const LoggedInDevAI = () => {
    return <LoggedInDevAIFree />;
};
